var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21094 4.28125L12.6189 11.9167",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3865 11.5164L1.51793 14.041L0.824219 12.8341L8.44251 4.68555",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88281 13.4895L4.48167 14.5249C4.69869 14.897 5.05463 15.1676 5.47117 15.2772C5.88772 15.3869 6.33075 15.3265 6.70281 15.1095C7.07487 14.8925 7.34548 14.5366 7.45511 14.12C7.56474 13.7035 7.50441 13.2604 7.28738 12.8884L7.19138 12.7227",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50977 2.09916V0.666016",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 7.58984H15.4292",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58984 7.58984H3.02184",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61328 2.69336L4.62585 3.70707",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3906 3.70707L13.4032 2.69336",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referral-icon.143cf06130025699a3972e1d8d1a1046.svg";
export { ForwardRef as ReactComponent };